import { Link } from "react-router-dom";
import { Mail, Linkedin, Instagram } from "lucide-react";
import { navPrimary, site } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/10 bg-ink-base"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-10 w-10 grid place-items-center bg-burnt text-white font-heading font-bold">
                EG
              </span>
              <span className="font-heading font-semibold text-lg text-white">
                {site.honorific} {site.fullName}
              </span>
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={`mailto:${site.contact.email}`}
                data-testid="footer-email"
                aria-label="Email"
                className="h-10 w-10 grid place-items-center border border-white/10 text-zinc-400 hover:text-white hover:border-burnt transition-colors"
              >
                <Mail size={18} />
              </a>
              <a
                href={site.contact.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="h-10 w-10 grid place-items-center border border-white/10 text-zinc-400 hover:text-white hover:border-burnt transition-colors"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={site.contact.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="h-10 w-10 grid place-items-center border border-white/10 text-zinc-400 hover:text-white hover:border-burnt transition-colors"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-7 md:col-start-6">
            <p className="label-eyebrow mb-5">Explore</p>
            <ul className="grid grid-cols-2 gap-x-8 gap-y-3">
              {navPrimary.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-zinc-400 hover:text-white transition-colors text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">
            © {new Date().getFullYear()} {site.fullName}. All rights reserved.
          </p>
          <p className="text-zinc-600 text-xs uppercase tracking-[0.2em]">
            {site.brandTagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
